var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPic = function SvgPic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 184
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pic_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pic_svg__b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pic_svg__c"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pic_svg__d"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 58)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E13E54",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m18.9 18.2 3 3a.5.5 0 1 1-.8.7l-3-3a5 5 0 1 1 .7-.7zM15 19a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#6D7278",
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pic_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "m16 9-3.5 5h7l-3.4-5zm1.3 0H20c.6 0 1.3.3 1.6.8l3.1 3.7c.2.1.3.3.3.5h-4.2l-3.5-5zm-2.6 0H12c-.5 0-1.3.3-1.6.8l-3.1 3.7a2 2 0 0 0-.3.5h4.2l3.5-5zm2.6 14.7.1-.1 7.2-7.2c.4-.4.6-.9.6-1.4H20l-2.6 8.7zm-1.2.5h-.2L13.2 15h5.6l-2.7 9.2zM6.8 15c0 .5.2 1 .6 1.4l7.2 7.2.1.1-2.6-8.7H6.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD229",
    d: "M45.7 76h16.6c2.7 0 3.7.3 4.6.8 1 .5 1.8 1.3 2.3 2.3.5 1 .8 2 .8 4.6v16.6c0 2.7-.3 3.7-.8 4.6-.5 1-1.3 1.8-2.3 2.3-1 .5-2 .8-4.6.8H45.7c-2.7 0-3.7-.3-4.6-.8-1-.5-1.8-1.3-2.3-2.3-.5-1-.8-2-.8-4.6V83.7c0-2.7.3-3.7.8-4.6.5-1 1.3-1.8 2.3-2.3 1-.5 2-.8 4.6-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M49 100a5 5 0 0 1-1-10c.4-3.3 3-6 6-6 3.3 0 6 3.1 6 7v1a4 4 0 1 1 0 8H49z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#12AB66",
    d: "M45.7 114h16.6c2.7 0 3.7.3 4.6.8 1 .5 1.8 1.3 2.3 2.3.5 1 .8 2 .8 4.6v16.6c0 2.7-.3 3.7-.8 4.6-.5 1-1.3 1.8-2.3 2.3-1 .5-2 .8-4.6.8H45.7c-2.7 0-3.7-.3-4.6-.8-1-.5-1.8-1.3-2.3-2.3-.5-1-.8-2-.8-4.6v-16.6c0-2.7.3-3.7.8-4.6.5-1 1.3-1.8 2.3-2.3 1-.5 2-.8 4.6-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M54 122a8 8 0 0 1 .2 16H54a8 8 0 1 1 0-16zm0 3a4 4 0 0 0-4 4v5l2-2 2 2 2-2 2 2v-5a4 4 0 0 0-4-4zm-1.5 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#608381",
    d: "M45.7 152h16.6c2.7 0 3.7.3 4.6.8 1 .5 1.8 1.3 2.3 2.3.5 1 .8 2 .8 4.6v16.6c0 2.7-.3 3.7-.8 4.6-.5 1-1.3 1.8-2.3 2.3-1 .5-2 .8-4.6.8H45.7c-2.7 0-3.7-.3-4.6-.8-1-.5-1.8-1.3-2.3-2.3-.5-1-.8-2-.8-4.6v-16.6c0-2.7.3-3.7.8-4.6.5-1 1.3-1.8 2.3-2.3 1-.5 2-.8 4.6-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#553CDA",
    d: "M45.7 38h16.6c2.7 0 3.7.3 4.6.8 1 .5 1.8 1.3 2.3 2.3.5 1 .8 2 .8 4.6v16.6c0 2.7-.3 3.7-.8 4.6-.5 1-1.3 1.8-2.3 2.3-1 .5-2 .8-4.6.8H45.7c-2.7 0-3.7-.3-4.6-.8-1-.5-1.8-1.3-2.3-2.3-.5-1-.8-2-.8-4.6V45.7c0-2.7.3-3.7.8-4.6.5-1 1.3-1.8 2.3-2.3 1-.5 2-.8 4.6-.8z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pic_svg__b)",
    transform: "translate(38 38)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3 9h.1c.2 0 .4.2.4.5l-.4 3.5h3.3a.5.5 0 0 1 0 1h-3.4l-.6 4h4a.5.5 0 0 1 0 1h-4l-.5 3.6a.5.5 0 0 1-1 0v-.2l.4-3.4h-4l-.4 3.6a.5.5 0 0 1-1 0v-.2l.4-3.4H9.3a.5.5 0 0 1 0-1h3.4l.6-4h-4a.5.5 0 0 1 0-1h4l.5-3.6c0-.2.3-.4.5-.4h.1c.2 0 .4.2.4.5l-.4 3.5h4l.4-3.6c0-.2.3-.4.5-.4zm-1.6 9 .6-4h-4l-.6 4h4z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15 15h3l-1 2h-3z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E77438",
    d: "M45.7 0h16.6C65 0 66 .3 67 .8s1.8 1.3 2.3 2.3c.5 1 .8 2 .8 4.6v16.6c0 2.7-.3 3.7-.8 4.6-.5 1-1.3 1.8-2.3 2.3-1 .5-2 .8-4.6.8H45.7c-2.7 0-3.7-.3-4.6-.8-1-.5-1.8-1.3-2.3-2.3-.5-1-.8-2-.8-4.6V7.7c0-2.7.3-3.7.8-4.6.5-1 1.3-1.8 2.3-2.3 1-.5 2-.8 4.6-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F7FC7",
    d: "M7.7 96h16.6c2.7 0 3.7.3 4.6.8 1 .5 1.8 1.3 2.3 2.3.5 1 .8 2 .8 4.6v16.6c0 2.7-.3 3.7-.8 4.6-.5 1-1.3 1.8-2.3 2.3-1 .5-2 .8-4.6.8H7.7c-2.7 0-3.7-.3-4.6-.8-1-.5-1.8-1.3-2.3-2.3-.5-1-.8-2-.8-4.6v-16.6c0-2.7.3-3.7.8-4.6.5-1 1.3-1.8 2.3-2.3 1-.5 2-.8 4.6-.8z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pic_svg__c)",
    transform: "translate(0 96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 8)",
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4h18v1H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12,
    y: 4,
    opacity: 0.9,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1c0-.6.5-1 1-1h5l2 2H0V1zm0 1h17c.6 0 1 .4 1 1v1H0V2z",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#7AA3C1",
    d: "M7.7 134h16.6c2.7 0 3.7.3 4.6.8 1 .5 1.8 1.3 2.3 2.3.5 1 .8 2 .8 4.6v16.6c0 2.7-.3 3.7-.8 4.6-.5 1-1.3 1.8-2.3 2.3-1 .5-2 .8-4.6.8H7.7c-2.7 0-3.7-.3-4.6-.8-1-.5-1.8-1.3-2.3-2.3-.5-1-.8-2-.8-4.6v-16.6c0-2.7.3-3.7.8-4.6.5-1 1.3-1.8 2.3-2.3 1-.5 2-.8 4.6-.8z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pic_svg__d)",
    transform: "translate(0 134)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M26 16.5a9.5 9.5 0 1 0-19 0 9.5 9.5 0 0 0 19 0zm-10-2.4L14.3 16H13l3.5-4 3.5 4h-1.3L17 14v7h-1v-7z"
  })))));
};
export default SvgPic;